import { DictionaryPage, SpecialSymbolsPage } from './views';

let routes = [
    {
        path: '/dictionary',
        name: 'dictionary',
        component: DictionaryPage,
        meta: {
            title: 'Словарь фраз',
        },
    },
    {
        path: '/special_symbols',
        name: 'special_symbols',
        component: SpecialSymbolsPage,
        meta: {
            title: 'Словарь специальных символов',
        },
    },
];

export default routes;
